import {PrsToPay} from "store/post-results-services/postResultsServicesApi";

import SideSectionProductsSummary from "./SideSectionProductsSummary";

export interface SelectPaymentSideSectionProps {
    prss: PrsToPay[];
    total: string;
    taxInfo?: string;
}

export const SelectPaymentSideSection = ({total, prss, taxInfo} : SelectPaymentSideSectionProps) => {
    return (
        <SideSectionProductsSummary total={total} prss={prss} taxInfo={taxInfo} />
    )
}